import { appConfig } from "../appconfig";
import { AuthClient, LoginResponseDto } from "../web-api-client";
import { fetchWithTimeout } from "./fetchWithTimeout";
import { tokenStore } from "./tokenStore";

const authClient = new AuthClient(appConfig.apiBaseUrl, {
  fetch: fetchWithTimeout(),
});

// Promise dùng chung cho tất cả request đang chờ refresh
let currentRefreshPromise: Promise<string | null> | null = null;

/**
 * Gọi /api/Auth/auth/refresh để lấy access token mới.
 * Đảm bảo cùng lúc chỉ có 1 request refresh đang chạy.
 */
export function refreshAccessToken(): Promise<string | null> {
  // Nếu đã có 1 refresh đang chạy → dùng chung promise đó
  if (currentRefreshPromise) {
    return currentRefreshPromise;
  }

  currentRefreshPromise = (async () => {
    try {
      const res: LoginResponseDto = await authClient.postApiAuthAuthRefresh();

      if (!res || !res.accessToken) {
        tokenStore.clear();
        return null;
      }

      const expiresInSeconds = res.expiresIn ?? 0;
      const expiresAt = Date.now() + expiresInSeconds * 1000;

      tokenStore.set(res.accessToken, expiresAt);

      return res.accessToken;
    } catch (err) {
      console.error("Refresh token thất bại:", err);
      tokenStore.clear();
      return null;
    } finally {
      // reset để lần sau có thể refresh lần mới
      currentRefreshPromise = null;
    }
  })();

  return currentRefreshPromise;
}
